if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"gaxl_web_host","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(194|21|34)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}